import { scannerMessages } from "constants/scanner.messages";

export const SHEARWELL_SDL440S_SCANNER_DRIVER_NAME = "shearwellsdl440s-scanner";
export const SHEARWELL_SDL440S_CAPABILITIES = [
  scannerMessages.READ_SAVED_SCANS,
  scannerMessages.ERASE_SAVED_SCANS,
  scannerMessages.READ_DEVICE_TIME,
  scannerMessages.UPDATE_DEVICE_TIME,
];
